export default __webpack_public_path__ + "static/media/thumb_up.38cd9dc5.svg";